export default function WorkflowActivationTab({ globalActiveWorkFlow, onToggle, isDatabaseConfigured = false }) {
  const handleToggle = () => {
    // if (!isDatabaseConfigured) {
    //   return;
    // }
    onToggle(!globalActiveWorkFlow);
  };

  return (
    <div className="py-5">
      <div className="mb-5 border-b border-gray-200 pb-5">
        <h2 className="text-lg font-medium text-gray-900">
          Global Workflow Activation
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          Control whether your workflow is active or inactive. When inactive, the workflow will not process any triggers or actions.
        </p>
      </div>

      {!isDatabaseConfigured && (
        <div className="mb-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-800">
            Please configure your database connection before activating the workflow.
          </p>
        </div>
      )}

      <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border border-gray-200">
        <div className="flex items-center gap-3">
          <div className={`h-3 w-3 rounded-full ${globalActiveWorkFlow ? 'bg-green-500' : 'bg-gray-400'}`}></div>
          <div>
            <p className="text-sm font-medium text-gray-900">
              Workflow Status: {globalActiveWorkFlow ? "Active" : "Inactive"}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              {globalActiveWorkFlow
                ? "Your workflow is currently processing triggers and actions"
                : "Your workflow is currently paused and will not process any triggers or actions"}
            </p>
          </div>
        </div>
        <button
          onClick={handleToggle}
        //   disabled={!isDatabaseConfigured}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            !isDatabaseConfigured
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : globalActiveWorkFlow
              ? "bg-red-100 text-red-700 hover:bg-red-200"
              : "bg-green-100 text-green-700 hover:bg-green-200"
          }`}
        >
          {globalActiveWorkFlow ? "Deactivate" : "Activate"}
        </button>
      </div>
    </div>
  );
}

